<div class="app">
    <!-- Full-page loading overlay for MSAL token exchange -->
    <div class="msal-loading-overlay" *ngIf="msalExchangeLoading$ | async">
        <app-loading-spinner></app-loading-spinner>
    </div>

    <router-outlet></router-outlet>
    <app-redirect *ngIf="msalEnabled"></app-redirect>
</div>
<!-- TODO Reinstate -->
<!--<app-confirmation-modal></app-confirmation-modal>-->
